import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWebmToMp4ConverterConfig } from '@/data/landingConfig/landingWebmToMp4ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WebmToMp4Converter } from './schemaObject';

interface Props {}
const WebmToMp4Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WebmToMp4Converter} />
			<VideoLandingTemplate
				data={landingWebmToMp4ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default WebmToMp4Converter;
